import { BookingPartialPaymentCUModel } from './booking-partial-payment-cu-model';

/**
 * For Create and Update
 */
export class RecourseBookingCUModel {
  public pkBookingId: number;
  public bookingType: string;
  public invoiceReasonText: string;
  public bookingStateId: number;
  public recourseTypeId: number;
  public referencedBookingId: number;
  public recourseId: string;
  public partialPaymentItems: BookingPartialPaymentCUModel[];
  public revenueOrderNumber: string;
  public supplierId: string;
  public bookingJustificationComment: string;
}
